module.exports = __webpack_public_path__ + "static/media/gg.dabaf20d.svg";